import React from 'react';
import './TravelKitIllustration.css';

export default function TravelKitIllustration() {
  return (
    <div className="tp-travel-kit-illustration">
      <svg viewBox="0 0 300 190" className="tp-travel-kit-illustration__svg" role="img" aria-label="A small dark violet Faye zippered amenity pouch">
        <ellipse cx="150" cy="180" rx="120" ry="10" fill="rgba(21,7,49,0.12)" />

        <rect x="20" y="26" width="260" height="144" rx="24" fill="#291660" />
        <path d="M20 50 a24 24 0 0 1 24-24 h212 a24 24 0 0 1 24 24 v10 H20 Z" fill="#150731" />

        <rect x="4" y="34" width="26" height="18" rx="8" fill="#EAB77A" />

        <path
          d="M34 51 h232"
          fill="none"
          stroke="#4726D1"
          strokeWidth="2.5"
          strokeDasharray="1 6"
          strokeLinecap="round"
        />
        <rect x="248" y="43" width="10" height="17" rx="3" fill="#4726D1" />
        <circle cx="253" cy="41" r="6" fill="none" stroke="#4726D1" strokeWidth="2.5" />

        <image href="/assets/faye-logo-white.png" x="105" y="98" width="90" height="45.4" />
      </svg>
    </div>
  );
}
